import * as React from "react";
import { formatRut } from "../../../helperComponents/InputRut/rutValidate";
import { FaPen, FaInfoCircle } from "react-icons/fa";
import * as moment from "moment";
import "./claim.scss";
import { claimStatusFormatted } from "../ClaimForm/utils";
import { colorStatus } from "../helper/claimHelper";
import { fullName } from "../../../helperComponents";

var ListClaims = function ListClaims(props) {
  var claims = props.claims,
      admin = props.admin;
  var canEdit = admin.is_super_admin || admin.permissions_code.includes("claim_edit");

  if (claims && claims.length > 0) {
    return /*#__PURE__*/React.createElement("table", {
      className: "table table-striped table-sm table-bordered col-md-10 cntListClaim",
      "data-toggle": "table"
    }, /*#__PURE__*/React.createElement("thead", {
      className: "tableHeader"
    }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "N\xBA Siniestro"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "N\xBA P\xF3liza"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Asegurado"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Estado Siniestro"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Ramo"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Cobertura"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Provisi\xF3n"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Compa\xF1\xEDa"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Fecha Siniestro"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Fecha Denuncia"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Indemnizaci\xF3n Final"), /*#__PURE__*/React.createElement("th", {
      scope: "col",
      style: {
        width: "250px"
      }
    }, "Acciones"))), /*#__PURE__*/React.createElement("tbody", {
      className: "tableBody"
    }, claims && claims.map(function (claim) {
      var _claim$poliza$company;

      return /*#__PURE__*/React.createElement("tr", {
        key: claim.id
      }, /*#__PURE__*/React.createElement("td", null, claim.claim_number ? claim.claim_number : "-"), /*#__PURE__*/React.createElement("td", null, claim.poliza.code ? /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(claim.poliza.id)
      }, claim.poliza.code) : "-"), /*#__PURE__*/React.createElement("td", null, claim.poliza.asegurado ? "".concat(fullName(claim.poliza.asegurado), " ").concat(formatRut(claim.poliza.asegurado.rut || "")) : "-"), /*#__PURE__*/React.createElement("td", null, colorStatus(claim.status), " ", claimStatusFormatted(claim.status)), /*#__PURE__*/React.createElement("td", null, claim.poliza.ramo ? claim.poliza.ramo : "-"), /*#__PURE__*/React.createElement("td", null, claim.coverage ? claim.coverage : "-"), /*#__PURE__*/React.createElement("td", null, claim.forecast_price ? claim.forecast_price : "-"), /*#__PURE__*/React.createElement("td", null, ((_claim$poliza$company = claim.poliza.company) === null || _claim$poliza$company === void 0 ? void 0 : _claim$poliza$company.name) || "-"), /*#__PURE__*/React.createElement("td", null, claim.claim_date ? moment(claim.claim_date).format("DD-MM-YYYY") : "-"), /*#__PURE__*/React.createElement("td", null, claim.request_date ? moment(claim.request_date).format("DD-MM-YYYY") : "-"), /*#__PURE__*/React.createElement("td", null, claim.final_compensation ? claim.final_compensation : "-"), /*#__PURE__*/React.createElement("td", {
        className: "action-td"
      }, /*#__PURE__*/React.createElement("a", {
        target: "_blank",
        href: "/admin/polizas/".concat(claim.poliza.id, "/claims"),
        className: "btn btn-default btn-mini"
      }, /*#__PURE__*/React.createElement(FaInfoCircle, null)), canEdit && /*#__PURE__*/React.createElement("a", {
        target: "_blank",
        href: "/admin/polizas/".concat(claim.poliza.id, "/claims/").concat(claim.id, "/edit"),
        className: "btn btn-default btn-mini"
      }, /*#__PURE__*/React.createElement(FaPen, null))));
    })));
  }

  return /*#__PURE__*/React.createElement("h3", null, "No se han encontrado Siniestros.");
};

export default ListClaims;